import { Card, Box, Avatar, Typography, Button, Stack } from '@mui/material';

export default function ModuleHeader({ icon, title, subtitle, actionLabel, actionIcon, onAction }) {
  return (
    <Card sx={{ mb: 3, overflow: 'hidden' }}>
      <Box sx={{
        background: (t) => `linear-gradient(135deg, ${t.palette.primary.main} 0%, ${t.palette.secondary.main} 100%)`,
        color: '#fff', p: { xs: 2.5, md: 3 },
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: 2,
      }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 52, height: 52 }}>
            {icon}
          </Avatar>
          <Box>
            <Typography variant="h5" fontWeight={800}>{title}</Typography>
            {subtitle && (
              <Typography variant="body2" sx={{ opacity: 0.85 }}>{subtitle}</Typography>
            )}
          </Box>
        </Stack>
        {actionLabel && onAction && (
          <Button variant="contained" color="inherit" startIcon={actionIcon} onClick={onAction}
            sx={{ bgcolor: '#fff', color: 'primary.main', '&:hover': { bgcolor: '#f0f0f0' } }}>
            {actionLabel}
          </Button>
        )}
      </Box>
    </Card>
  );
}
